export default function ErrorComponent({ errorMsg }: { errorMsg?: string }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <p className=" text-lg font-bold mb-2 font-pretendard">
          데이터를 불러오는 중 오류가 발생했습니다
        </p>
        <p className="text-gray-600 text-sm font-pretendard">
          {errorMsg || "잠시 후 다시 시도해주세요"}
        </p>
        <button
          onClick={() => window.location.reload()}
          className=" border border-zinc-300  text-zinc-400 mt-5! rounded-full p-5 px-9 hover:border-zinc-600 font-pretendard"
        >
          새로고침
        </button>
      </div>
    </div>
  );
}
